import { render, staticRenderFns } from "./KitBody.vue?vue&type=template&id=776b5467"
import script from "./KitBody.vue?vue&type=script&lang=js"
export * from "./KitBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports